// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, "\n.with-scroll[data-v-2e2fcaa8]{\n  max-height : 300px!important;\n  overflow-y: scroll;\n}\n", ""]);
// Exports
module.exports = exports;
